import React from "react";
import TeamMembers from "../components/TeamsMembers";
import Overview from "../components/Overview";

const Home = () => {
  return (
    <>
      <Overview />
      <TeamMembers />
    </>
  );
};

export default Home;
